import { render, staticRenderFns } from "./JobMatchPage.vue?vue&type=template&id=25eb2d0b&lang=pug&"
import script from "./JobMatchPage.vue?vue&type=script&lang=ts&"
export * from "./JobMatchPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25eb2d0b')) {
      api.createRecord('25eb2d0b', component.options)
    } else {
      api.reload('25eb2d0b', component.options)
    }
    module.hot.accept("./JobMatchPage.vue?vue&type=template&id=25eb2d0b&lang=pug&", function () {
      api.rerender('25eb2d0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-match/JobMatchPage.vue"
export default component.exports